// Style Guide v1

export default {
  // Primary
  prussian: '#2d344b',
  prussian200: '#f0f2f6',
  prussian300: '#dfe1e7',
  prussian400: '#c6c9d5',
  prussian500: '#9ea3b7',
  prussian600: '#757D99',
  prussian700: '#47506b',
  prussianMid: '#576183',
  orange: '#f36e21',
  orange100: '#feede3',
  orange800: '#e55c0c',
  peach: '#faa918',
  peach100: '#fef1d9',
  peach200: '#fde2b2',
  peach300: '#ffefc8',
  jungle: '#3a833c',
  jungle100: '#ecf7ee',
  jungle200: '#d4e8d9',
  tomato: '#e06c4f',
  brown: '#92613a',
  // Secondary
  gold: '#f7ce6a',
  blonde: '#fffae5',
  shadesPeach100: '#fff4d9',
  leaf: '#61c16c',
  mint: '#e6f4e9',
  mint600: '#c5e8c9',
  jungle300: '#d4e8d9',
  // Neutral
  slate: '#707070',
  stone: '#b5b5b5',
  silver: '#d9d9d9',
  mercury: '#e8e8e8',
  iron: '#969696',
  charcoal: '#545454',
  platinum: '#efeff0',
  white: '#ffffff',
  neutralAsh: '#8b8b8b',
  // Special
  soil: '#814026',
  dragon: '#ac0b1f',
  dragon200: '#fde3e6',
  dragon100: '#fef1f2',
  red: '#a2191f',
  rose: '#ffd7d9',
  lightPrussian: '#f0f2f6',
  midnight: '#383838',
  focusOutlineColor: '#1D5995',
  shadesJungle500: '#9ad7a1',
  shadesJungle700: '#48a34b',
  shadesJungle800: '#367a38',
};
